import React from 'react';
import DashboardCard from "components/DashboardCard";
import PropTypes from 'prop-types';



const Announcement = React.memo(
	({
		 variant = 'default',
		 headerContent = '',
		 size = 'xl',
		 children,
	 }) => (
		<DashboardCard
			color={getColor(variant)}
			headerContent={headerContent}
			size={size}
			variant="full"
		>
			{children}
		</DashboardCard>
	),
);



function getColor(variant) {
	switch(variant) {
		case 'success':
			return 'lightGreen';
		case 'warning':
			return 'amber';
		case 'danger':
		case 'error':
			return 'red';
		case 'blue':
			return 'blue';
		case 'blueGrey':
			return 'blueGrey';
		default:
			return 'grey';
	}
}



Announcement.propTypes = {
	size: PropTypes.oneOf([ 'xs', 'sm', 'md', 'lg', 'xl' ]).isRequired,
	variant: PropTypes.oneOf([ 'default', 'success', 'warning', 'danger', 'error', 'blue', 'blueGrey' ]).isRequired,
	headerContent: PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]).isRequired,
};


export default Announcement;